import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from '../../base-components/base-form.component';
import { AlertIntent } from '../../../shared/alert/alert.component';

@Component({
  moduleId: module.id,
  selector: 'tele-cmi-disabled',
  templateUrl: './tele-cmi-disabled.component.html',
})
export class TeleCMIdisabledComponent extends BaseFormComponent implements OnInit {
  private currentSection: number;
  alertIntent = AlertIntent;
  isAdvisor: boolean;

  ngOnInit() {
    this.currentSection = this.navigationService.currentSection;
    this.isAdvisor = this.appState.isAdvisor;
  }

  navigateToNextSection() {
    if (this.appState.canNavigateToNextSection(this.currentSection)) {
      this.navigationService.activeApplicationSection$.next(this.currentSection + 1);
    } else {
      this.applicationService.missedQuestionSubject.next();
    }
  }
  updateFromModel() {}
}
